<template>
    <div>
        <tw-modal :padding="false" :show="store.state.play.showRunnerSelection" @close="store.commit('toggleShowRunnerSelection')" title="Change Selection">
            <div class="overflow-y-auto">
                <button type="button" class="bg-white dark:bg-racing-stars-yellow rounded-md text-gray-400 dark:text-gray-800 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:dark:ring-racing-stars-yellow absolute top-2 right-2" @click="store.commit('toggleShowRunnerSelection')">
                    <span class="sr-only">Close panel</span>
                    <XIcon class="h-6 w-6" aria-hidden="true" />
                </button>
                <table class="min-w-full divide-y divide-gray-200 mt-4" v-if="store.getters.raceToModify">
                    <thead class="bg-gray-50 bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-900">
                        <tr>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Horse
                            </th>
                            <th scope="col" class="relative px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right transition duration-500 ease-in-out dark:text-white"></th>
                        </tr>
                    </thead>

                    <tbody class="bg-white divide-y divide-gray-300">
                        <template v-for="(runner, runnerKey) in store.getters.raceToModify.runners" :key="runnerKey">
                            <tr v-if="!runner.non_runner" class="dark:hover:bg-opacity-80 dark:bg-gray-700  dark:sm:bg-gray-800 bg-white text-xs md:text-base">
                                <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                                    <div class="flex items-center">
                                        <div class="shrink-0 h-10 w-10">
                                            <div class="shrink-0 mr-4 rounded-full bg-white p-2 w-10 h-10 flex items-center justify-center">
                                                <img class="w-10" :src="runner.silk_image_path" alt="" />
                                            </div>
                                        </div>
                                        <div class="ml-4">
                                            <div class="text-sm font-medium text-gray-900 transition duration-500 ease-in-out dark:text-white">
                                                {{ runner.non_runner ? 'Non-Runner' : runner.horse.name }}<br/>
                                                {{ runner.forecast_odds_description }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium transition duration-500 ease-in-out dark:text-white">
                                    <tw-button @click="changeSelection(runner)">
                                        <span class="hidden sm:block">Pick</span>
                                        <SwitchHorizontalIcon class="sm:hidden w-5 h-5" />
                                    </tw-button>
                                </td>
                            </tr>
                        </template>
                    </tbody>      
                </table>
            </div>
        </tw-modal>
    </div>
</template>
<script>
import { computed, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import Modal from '@/Global/Modal.vue'
import moment from 'moment'
import { XIcon, SwitchHorizontalIcon } from '@heroicons/vue/solid'
import { Inertia } from '@inertiajs/inertia'

export default {
    props: {
        user: Object,
    },
    setup(props) {


        const store = useStore()

        const changeSelection = (runner) => {

            let betForm = Inertia.form({
                runner: runner
            })

            betForm.patch('/bets/'+props.user.todays_bet.id, {
                onSuccess: () => {
                    store.commit('toggleShowRunnerSelection')
                }
            })
        }

        const close = () => {
            store.commit('toggleShowRunnerSelection')
        }

        const todaysBet = computed(() => {
            return props.user.todays_bet
        })

        return {
            changeSelection,
            close,
            store,
            todaysBet,
        }
    },

    components: {
        Modal,
        XIcon,
        SwitchHorizontalIcon,
        Inertia,
    }
}

</script>
